import React from 'react';
import { Colors } from '@common/tokens';
import { Icon } from '@common/components';

export const FileUploaderItem = ({
  fileName,
  onClick,
  onDelete,
  showDelete,
  color = 'elm',
  iconKind = 'light',
}: {
  fileName: string;
  onClick: () => void;
  showDelete?: boolean;
  onDelete?: () => void;
  color?: 'elm' | 'elmDarkest';
  iconKind?: 'light' | 'solid' | undefined;
}) => (
  <>
    <div className="FileUploaderItem">
      <div className="ant-upload-list-item ant-upload-list-item-list-type-text">
        <div className="ant-upload-list-item-info">
          <span onClick={onClick}>
            <Icon icon="paperclip" kind={iconKind} color="midnightRegular" />
            <span className="list-item-name">{fileName}</span>
          </span>
          {showDelete && (
            <span
              className="ant-upload-list-item-card-actions"
              onClick={onDelete}
            >
              <Icon icon="trash" kind="regular" color="midnightLighter" />
            </span>
          )}
        </div>
      </div>
    </div>
    <style jsx>{`
      .FileUploaderItem {
        width: 100%;
        cursor: pointer;
      }
      .FileUploaderItem .ant-upload-list-item {
        width: 100%;
      }
      .FileUploaderItem .list-item-name {
        padding-left: 8px;
        color: ${Colors[color]};
        cursor: pointer;
      }
      .FileUploaderItem .ant-upload-list-item-info {
        padding: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        display: inline-block;
      }
      .FileUploaderItem .ant-upload-list-item-info > span {
        width: auto;
        display: inline;
      }
    `}</style>
  </>
);
